<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
const store = {};

import $ from '@/js/vendor/jquery.min.js';

export default {
  name: 'App',
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue